import { render, staticRenderFns } from "./MerchantManage.vue?vue&type=template&id=6f75d54e&scoped=true"
import script from "./MerchantManage.vue?vue&type=script&lang=js"
export * from "./MerchantManage.vue?vue&type=script&lang=js"
import style0 from "./MerchantManage.vue?vue&type=style&index=0&id=6f75d54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f75d54e",
  null
  
)

export default component.exports